module.exports = __webpack_public_path__ + "img/cuerda.99b386d2.jpg";